import { BybBackground } from "@Components/game/common";
import PositionSelectorDialog from "@Components/game/common/position-selector/position-selector-dialog";
import SessionResultsLoadingOverlay from "@Components/game/common/session-results-loading-overlay";
import { GameModeContainer } from "@Components/game/game-mode";
import { PractiseOverview, PractiseSettings } from "@Components/game/practise";
import PhasesDialog from "@Components/game/practise/phases-dialog";
import ContainerWrapper from "@Components/generic/container-wrapper";
import { PractiseProvider, usePractiseContext } from "@Context/game/practise/practise-context";
import { Container, Stack, useTheme } from "@mui/material";

interface IPractise {}

const PRACTISE_BACKGROUND_URL = "https://challenge-thumbs.b-cdn.net/byb-mode-posters/img-practice-full.jpg";

const PractiseContent = ({}: IPractise) => {
  const theme = useTheme();
  const {
    selectedPositions,
    selectedPhases,
    isPhasesDialogOpen,
    closePhasesDialog,
    handlePhasesSelected,
    isPositionDialogOpen,
    closePositionDialog,
    handlePositionsSelected,
    isCompletingSession,
  } = usePractiseContext();

  return (
    <ContainerWrapper id="PRACTISE" fullHeight>
      <BybBackground imageUrl={PRACTISE_BACKGROUND_URL} />

      <Container maxWidth="xl">
        <Stack width="100%" paddingTop={theme.spacing(15)}>
          <GameModeContainer>
            <PractiseOverview />
            <PractiseSettings />
          </GameModeContainer>
        </Stack>

        {/* Dialogs */}
        <PositionSelectorDialog
          isOpen={isPositionDialogOpen}
          onClose={closePositionDialog}
          onPositionsSelected={handlePositionsSelected}
          initialPositions={selectedPositions}
        />
        <PhasesDialog open={isPhasesDialogOpen} selectedPhases={selectedPhases} onClose={closePhasesDialog} onConfirm={handlePhasesSelected} />
      </Container>

      <SessionResultsLoadingOverlay open={isCompletingSession} />
    </ContainerWrapper>
  );
};

const Practise = (props: IPractise) => (
  <PractiseProvider>
    <PractiseContent {...props} />
  </PractiseProvider>
);

export default Practise;
